import type { Translations } from "../types";

const nl: Translations = {
  "meta.title": "Klikken per land",
  "meta.description":
    "Interactieve wereldkaart: gratis kliks per land plus betaalde steun via Stripe, PayPal en Buy Me a Coffee.",

  "app.title": "Klikken per land",

  "map.intro":
    "Klik op een land op de kaart om er een gratis stem aan te geven, of stuur financiële steun - beide tellen mee voor het gecombineerde klassement hieronder. De kaart weerspiegelt alleen steun binnen deze app, niet de werkelijke nationale welvaart of het bbp.",
  "map.verifying": "Verifiëren …",
  "map.confirmNotRobot": "Voordat je gratis kliks kunt toevoegen, bevestig je snel dat je geen robot bent:",
  "map.tryAgain": "Opnieuw proberen",
  "map.registeringClick": "Klik registreren …",
  "map.selectedCountry": "Geselecteerd land: {name}.",
  "map.selectFirstFeedback": "Land geselecteerd. Bevestig hieronder eerst dat je geen robot bent om een gratis klik toe te voegen.",
  "map.verificationExpired": "Verificatie verlopen - bevestig opnieuw dat je geen robot bent.",
  "map.slowDown": "Iets langzamer - wacht even voor je volgende klik.",
  "map.clickFailed": "De klik kon niet worden geregistreerd. Probeer het opnieuw.",
  "map.clickErrorGeneric": "Fout bij het registreren van de klik.",
  "map.leaderboardHeading": "Landenklassement",
  "map.emptySelection": "Selecteer een land op de kaart om te klikken of te steunen.",
  "map.loadingData": "Gegevens laden …",

  "worldmap.loadError": "De kaart kon niet worden geladen.",
  "worldmap.resetZoom": "Zoom resetten",
  "worldmap.resetButton": "⤾ Reset",
  "worldmap.loadingMap": "Kaart laden …",
  "worldmap.unknownCountry": "Onbekend",
  "worldmap.ariaClicks": "{name}: {clicks} kliks",
  "worldmap.tooltipClicks": "{clicks} kliks",

  "legend.fewer": "Minder kliks",
  "legend.more": "Meer kliks",

  "list.empty": "Nog geen kliks. Wees de eerste!",
  "list.ariaLabel": "Landenklassement op basis van kliks",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY is niet ingesteld - zie de README voor configuratie.",
  "human.verificationFailedGeneric": "Verificatie mislukt.",
  "human.networkError":
    "Verificatie kon niet worden bereikt (netwerkfout) - controleer VITE_SUPABASE_URL, of verify-human is gedeployed, en ALLOWED_ORIGIN; zie README/NAVODILA.",
  "human.verificationFailedRetry": "Verificatie mislukt, probeer het opnieuw.",

  "provider.stripe": "💳 Kaart (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Geselecteerd land",
  "panel.currentlyRanked": "Momenteel op plek #{rank}",
  "panel.shareCopied": "Gekopieerd ✓",
  "panel.shareShared": "Gedeeld ✓",
  "panel.shareButton": "🔗 Delen",

  "panel.tableClicks": "Kliks",
  "panel.tableFree": "Gratis",
  "panel.tablePaid": "Betaald",
  "panel.rowAllTime": "Aller tijden",
  "panel.rowThisYear": "Dit jaar",
  "panel.rowThisWeek": "Deze week",
  "panel.rowToday": "Vandaag",

  "panel.totalCombined": "Totaal gecombineerd:",
  "panel.totalSupport": "Totale steun:",

  "panel.paymentMethod": "Betaalmethode",
  "panel.noPaymentMethod": "Er is momenteel geen betaalmethode beschikbaar.",
  "panel.supportAmount": "Steunbedrag (EUR)",
  "panel.amountRange": "Het bedrag moet tussen {min} en {max} liggen.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Geschatte betaalde kliks:",
  "panel.ratioInfo":
    "Verhouding: {a} = {b} kliks (bijv. {c} = {d} kliks). Dit is slechts een schatting vóór betaling - het uiteindelijke aantal kliks wordt altijd berekend en bevestigd door de server op basis van de daadwerkelijk bevestigde betaling.",
  "panel.preparing": "Voorbereiden …",
  "panel.continueWith": "Doorgaan met {provider}",
  "panel.choosePaymentMethod": "Kies een betaalmethode",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME is niet ingesteld - zie de README voor configuratie.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID is niet ingesteld - zie de README voor configuratie.",

  "panel.paypalAmountInfo": "Bedrag: {amount} (geschat {clicks} kliks). Rond de betaling af met de PayPal-knop hieronder.",
  "panel.back": "← Terug",

  "panel.bmcWarningTitle": "⚠️ Voordat je doorgaat naar BuyMeCoffee:",
  "panel.bmcWarningBody":
    "Plak de onderstaande code in het bericht-/notitieveld bij het afrekenen — dat is de enige manier waarop we weten welk land je steunt. Zonder de code kunnen we de betaling aan geen enkel land koppelen.",
  "panel.copy": "Kopiëren",
  "panel.copied": "Gekopieerd ✓",
  "panel.suggestedAmount": "Voorgesteld bedrag:",
  "panel.bmcAmountNote":
    "(geschat {clicks} kliks). BuyMeCoffee ondersteunt helaas niet het doorgeven van het bedrag via de link — voer het zelf in/selecteer het op hun site. Het werkelijke aantal kliks wordt altijd berekend op basis van het bedrag dat je daadwerkelijk via BuyMeCoffee verstuurt, niet op basis van deze schatting.",
  "panel.openBmc": "Open BuyMeCoffee en ga verder →",
  "panel.waitingProvider": "Wachten op betalingsbevestiging van de betalingsprovider …",
  "panel.waitingConfirmation": "Wachten op betalingsbevestiging …",
  "panel.timedOut":
    "Controle duurde te lang. Als je de betaling hebt voltooid, wordt de kaart bijgewerkt zodra de server een bevestiging ontvangt - dit kan soms iets langer duren.",
  "panel.checkAgain": "Opnieuw controleren",

  "panel.cancelled": "De betaling is geannuleerd of niet gelukt. De kaart is niet gewijzigd.",
  "panel.tryAgain": "Opnieuw proberen",

  "panel.confirmed": "✅ Steun bevestigd!",
  "panel.confirmedBody": "{country} ontving {clicks} betaalde kliks voor {amount}.",

  "panel.errorPreparingSupport": "Fout bij het voorbereiden van je steun.",
  "panel.errorPreparingPayment": "Fout bij het voorbereiden van de betaling.",
  "panel.errorConfirmingPayment": "Fout bij het bevestigen van de betaling.",
  "panel.errorPayingPaypal": "Fout bij betalen met PayPal.",

  "share.unranked": "{flag}{country} heeft jouw steun nodig op de wereldkaart!\nHelp het land stijgen in het klassement 👇",
  "share.rank1": "{flag}{country} staat momenteel op #1!\nHelp ons bovenaan te blijven 👇",
  "share.rankN": "{flag}{country} staat momenteel op #{rank}!\nHelp ons naar #1 👇",

  "language.switcherLabel": "Taal",
};

export default nl;
